<<template>
<div ref="basePanel">    
  <param-panel :config="config" :rs="rs" /><pager-panel :crowCount="config.rowCount" :cpageNo="config.pageNo" :cpageSize="config.pageSize"
  @CFHandler="CFHandler" :selIdx="selIdx" :rightList="config.rights">
  </pager-panel><list-panel @updateIdx="updateIdx" :selIdx="selIdx" :config="config" :isAutoLoad='1' :rs="rs" />
</div>
</template>


<script>
import data from "./data";
import mixin from "@/fui/mixin";

export default {
  created(){
    if (this.config.dept) {
      this.config.dept.forEach(d => {
        this.config.params.deptNo.options.push({
          value: d.deptNo,
          text: d.deptName
        });
      });
    }
  },
  data() {
    return {
      config: data,
      showDetail: false,
      showBatch: false
    };
  },
  methods: {
    add(){
      this.showDetail = true 
    },
    batch(){
      this.showBatch = true 
    },
    closeDetail(){
      this.showDetail = false
      this.$loadData(this.config)
    },
    closeBatch(){
      this.showBatch = false
      this.$loadData(this.config)
    }
  },
  mixins:[mixin.list]
};
</script>
